import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

const CustomList = (props) => {

    const [open, setOpen] = React.useState(false);

    return (
        <FormControl
            required={props.required}
            error={hasErrors(props)}
            fullWidth
        >
            <InputLabel id={props.id+"label"}>{props.label}</InputLabel>
            <Select
                labelId={props.id+"label"}
                id={props.id+"select"}
                label={props.label}
                value={props.value}
                open={open}
                onClose={()=>setOpen(false)}
                onOpen={()=>setOpen(true)}
                inputProps={{
                    name:props.name
                }}
                onBlur={
                    (e)=>{
                        props.updaterTouch(true)
                    }
                }
            >
                <MenuItem value="">
                    <em>Keine Auswahl</em>
                </MenuItem>
                {displayEintraege(props.list, props.value,  props.id, props.updaterValue, props.updaterTouch, setOpen)}
            </Select>
            <FormHelperText>
                { hasErrors(props) &&
                    errorText(props)
                }
            </FormHelperText>

        </FormControl>
    );
}

const hasErrors = (props) => {
    if (!props.hasOwnProperty("validator") || !props.touched) {
        return false;
    }
    return !props.validator().valid
}

const errorText = (props) => {
    return props.validator().message
}


const displayEintraege = (list, value, id, updaterValue, updaterTouch, setOpen) => {
    var arr = []
    list.forEach(
        (obj, index) => arr.push(
            <ListItem 
                key={'smk_'+id+index} 
                value={obj.id}
            >
                <ListItemButton
                    //selected={obj.id == value}
                    onClick={
                        ()=>{
                            updaterValue(obj.id)
                            updaterTouch(true)
                            setOpen(false)
                        }
                    }
                >
                    <ListItemAvatar>
                        <Avatar>{obj.avatar}</Avatar>
                    </ListItemAvatar>
                    <ListItemText
                        secondary={<React.Fragment>{obj.label}</React.Fragment>}
                    />
                </ListItemButton>
            </ListItem>


        )
    )

    return arr
  }

export default CustomList;
